<template>
  <div>
    <div class="iotplt-card-box">
      <search-profile-goods @submit="submitSearch" />
    </div>

    <div style="padding-top: 15px">
      <a-empty v-if="!loading && data.length === 0" />
      <a-row :gutter="24" v-else>
        <a-col :span="8">
          <product-card :data="data" :loading="loading" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { findProfileGoods } from '@/api/profile_goods'
import SearchProfileGoods from '@/views/agent_purchase_items/profile_goods/Search'
import ProductCard from '@/views/agent_purchase_items/profile_goods/ProductCard'

export default {
  name: 'ProfileGoodsList',
  components: {
    SearchProfileGoods,
    ProductCard
  },
  data() {
    return {
      loading: true,
      data: [],
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findProfileGoods(
        Object.assign({ agent_id: this.$store.getters.userAgentId }, this.query)
      ).then((res) => {
        if (res.code === 0) {
          this.data = res.data || []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
